Controller = App.loadClass 'core::Angular/Controller'
CropYear = App.loadClass 'core::CropYear'

class exports.SidebarController extends Controller
    constructor: (@scope, @transitions, @service, @state, @q, @stateParams, @http, @timeout, @modal, @window) ->
        super

        @scope.show_fullpage = false
        @scope.show_fullpage_fn = @showFullpage
        @scope.disableSummaryReportButton = true
        @scope.disableSummaryReportCheckbox = true
        @scope.summaryReportHistoricalData = false

        @scope.selected_options = {
            year: new CropYear().get()
            crop: null
        }

        @scope.service = @service
        @scope.years = []
        @scope.crops = []
        @scope.surveys = []

        # It is rare but conceivable that we could be in the middle of
        # saving when the sidebar controller initializes. For example,
        # if you go to the last step, fill out all the required fields,
        # then click on N Solver in the navbar. This will save the
        # survey and simultaneously reload the sidebar. This means that
        # we need to wait for it to finish saving before fetching the
        # surveys so that we can see that the survey they just left is
        # complete.
        if @service.saving
            @service.saving.then @getSurveys
        else
            @getSurveys()

        @scope.createError = null

        @scope.startSurvey = @startSurvey
        @scope.editSurvey = @editSurvey
        @scope.firstIncompleteStepIndex = @firstIncompleteStepIndex
        @scope.inNSolverProcess = @inNSolverProcess
        @scope.gotoStep = @gotoStep
        @scope.surveyExists = @surveyExists
        @scope.incompleteSurveys = @incompleteSurveys
        @scope.completeFieldSurveysForSurvey = @completeFieldSurveysForSurvey
        @scope.exitSurvey = @exitSurvey
        @scope.seeIfDisableSummaryReport = @seeIfDisableSummaryReport
        @scope.createSummaryReport = @createSummaryReport

        @scope.currentStepIs = @currentStepIs
        @scope.stepVisited = @stepVisited
        @scope.stepSaved = @stepSaved

        @service.brandNew = false

        @service.reset()

        @service.configLoaded.then () =>
            unless @service.config.crops
                @state.go 'grower.fields'
            @scope.crops = @service.config.crops

        @http.get('api/crops').then (response) =>
            @allCrops = response.data

    getSurveys: () =>
        @http.get('api/nitrogen-surveys')
        .then (response) =>
            @scope.surveys = response.data

            years = []
            for survey in @scope.surveys
                years.push survey.year

            years.push new CropYear().get()
            years.push (new CropYear().get()) - 1

            years = _.uniq(years).sort()

            @scope.years = years

    startSurvey: () =>
        crop = _.find(@allCrops, { name: @scope.selected_options.crop })

        @service.reset()
        @service.createSurvey(@scope.selected_options.year, crop.id).then (response) =>
            @scope.createError = null
            @service.brandNew = true
            @scope.surveys.push response.data
            @service.gotoStep 0, response.data.id, false
        .catch (error) =>
            if error.status is 422
                @scope.createError = error.data

                @timeout () =>
                    @scope.createError = null
                , 5000

    editSurvey: (survey) =>
        if not survey
            survey = @surveyExists()

        @service.reset()
        @service.brandNew = false

        @service.year = survey.year
        @service.crop = survey.crop.name
        @service.survey = survey

        # Go to the first incomplete step
        stepIndex = @firstIncompleteStepIndex(survey) or 0

        @service.gotoStep stepIndex, survey.id, false

    firstIncompleteStepIndex: (survey = @survey) =>
        return _.find @service.config.steps, (stepConfig, stepName) =>
            not @service.stepComplete(stepName, survey)
        ?.order

    surveyExists: () =>
        _.find @scope.surveys, (survey) =>
            survey.year is @scope.selected_options.year and survey.crop.name is @scope.selected_options.crop

    incompleteSurveys: (year) =>
        _.filter @scope.surveys, { year }
        .filter (survey) =>
            not @service.surveyComplete(survey)

    completeFieldSurveysForSurvey: (survey) =>
        _.filter survey.fields_nitrogen_surveys, (fieldSurvey) =>
            @service.fieldSurveyComplete fieldSurvey

    gotoStep: (stepName) =>
        @service.gotoStep @service.findStepIndexByName(stepName), @stateParams.surveyId

    showFullpage: () =>
        @inNSolverProcess()

    inNSolverProcess: () =>
        @state.includes 'grower.nsolver.step'

    currentStepIs: (stepName) =>
        stepName is @service.currentStepName

    stepVisited: (stepName) =>
        @service.survey?.visited_steps.indexOf(stepName) isnt -1

    stepSaved: (stepName) =>
        @service.survey?.saved_steps.indexOf(stepName) isnt -1

    exitSurvey: () =>
        @state.go 'grower.nsolver', {}, reload: 'grower.nsolver'

    seeIfDisableSummaryReport: () =>
        selectedSurvey = @surveyExists()

        if not selectedSurvey
            return

        @http.get "/backend/grower/nsolver/#{selectedSurvey.id}/count"
        .then (response) -> response.data
        .then (counts) =>
            @scope.disableSummaryReportCheckbox = counts.historical is 0
            @scope.disableSummaryReportButton = if @scope.summaryReportHistoricalData then false else counts.count is 0

    createSummaryReport: () =>
        selectedSurvey = @surveyExists()
        @window.open "/backend/grower/nsolver/#{selectedSurvey.id}/report" + if @scope.summaryReportHistoricalData then '/historical' else ''
        return
